import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from 'react'
import { Trans } from 'react-i18next'
import { MobileIcon } from 'src/editor/shared/ui-lib/mobile-icon'
import { twMerge } from 'tailwind-merge'
import { HorizontalLine } from './horizontal-line'

interface GroupTitleProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    PropsWithChildren {
  afterChildren?: React.ReactNode
  /** @deprecated This prop is deprecated. Use withoutHorizontalLine prop instead */
  isFirst?: boolean
  withoutHorizontalLine?: boolean
  className?: string
  isMobile?: boolean
}

export const GroupTitle = ({
  style,
  className,
  children,
  afterChildren,
  isMobile,
  isFirst,
  withoutHorizontalLine,
}: GroupTitleProps) => (
  <>
    {!isFirst && !withoutHorizontalLine && <HorizontalLine />}
    <div
      style={style}
      className={twMerge(
        'mt-9 mb-4 flex justify-between text-heading-5',
        className,
      )}
    >
      <Trans parent="span">{children}</Trans>
      {afterChildren}
      {isMobile && <MobileIcon />}
    </div>
  </>
)
